import Reflux from 'reflux-react-16'
import _ from 'lodash'
import socket from '../socketio/socketio.js'

import LoginActions from '../actions/LoginActions.js'
import {closeHandoverTab, isAdminToken, openHandoverTab, sendToken} from '../utils/loginAsHandover.js'
import {clearStoredDates} from '../utils/storedDates.js'
import moment from 'moment'

export default class LoginStore extends Reflux.Store {
    constructor() {
        super()

        this.listenables = LoginActions

        this.state = {
            reseller: {permissions: {}, settings: {carriers: [], parcels: {}, orders: {}}},
            user: {permissions: {}, settings: {parcels: {}, orders: {}}},
            accounts: [],
            branding: undefined,
            brandingLoading: true,
            selectedBranchIds: []
        }

        try {
            this.state.selectedBranchIds = JSON.parse(localStorage.selectedBranchIds || '[]')
        } catch {
            this.state.selectedBranchIds = []
        }

        sessionStorage.lastActiveTime = moment().toISOString(true)

        this.interval = setInterval(() => {
            if (moment().diff(moment(sessionStorage.lastActiveTime), 'hours') > 8) {
                LoginActions.logout()
            }
        }, 60000)

        window.document.addEventListener('click', () => {
            sessionStorage.lastActiveTime = moment().toISOString(true)
        }, {passive: false})

        const domain = window?.location.hostname

        if (!['localhost', 'dev.veloyd.nl', 'test.veloyd.nl', 'app.veloyd.nl'].includes(domain)) {
            LoginActions.getBranding(domain, (error, branding) => {
                if (!error && branding) {
                    this.setState({branding, brandingLoading: false})
                } else {
                    this.setState({brandingLoading: false})
                }
            })
        } else {
            this.state.branding = {}
            this.state.brandingLoading = false
        }

        if (sessionStorage.token) {
            LoginActions.getAccount()
            LoginActions.getReseller()
            LoginActions.getPartners()
        }

        socket.on('updateUser', () => {
            LoginActions.getAccount()
        })

        socket.on('updateReseller', (path) => {
            LoginActions.updateReseller(path)
        })

        socket.on('updatePartners', () => {
            LoginActions.getPartners()
            LoginActions.getReseller()
        })
    }

    onGetAccounts(email, password, callback) {
        socket.emit('login.getAccounts', email, password, callback)
    }

    onLogin(token, index, code, callback) {
        socket.emit('login.login', token, index, code, (err, token, decoded, reseller) => {
            if (err) {
                callback(err)
                return
            }

            if (checkRedirectToNewDomain(reseller?.domain, true, reseller?.settings?.brandingEnabled)) return

            if (decoded.isMessenger) {
                localStorage.mtoken = token
                // Making sure the localStorage.mtoken is being set
                setTimeout(() => {
                    window.location = '/koerier'
                }, 500)
            } else {
                sessionStorage.token = token

                this.setState({reseller, accounts: decoded.accounts})

                // Loaded on page load when already logged in, after a fresh login the partners are fetched here
                LoginActions.getPartners()

                LoginActions.getAccount((err, user) => {
                    callback(err, !err && this.link(user))
                })
            }
        })
    }

    onSwitchAccount(index, code, callback) {
        socket.emit('login.login', sessionStorage.token, index, code, (err, token, decoded, reseller) => {
            if (err) {
                callback(err, reseller)
                return
            }

            if (checkRedirectToNewDomain(reseller?.domain, true, reseller?.settings?.brandingEnabled)) return

            if (decoded.isMessenger) {
                localStorage.mtoken = token
                window.location = '/koerier'
            } else {
                sessionStorage.token = token

                LoginActions.getAccount((err, user) => {
                    window.location = this.link(user)
                })
            }
        })
    }

    // Actions are synchronous, so the tab is opened within the click (see loginAsHandover.js)
    onLoginAsReseller(id, url, callback, win = openHandoverTab()) {
        socket.emit('login.loginAsReseller', sessionStorage.token, id, (err, token) => {
            if (err) {
                closeHandoverTab(win)
            } else {
                sendToken(win, token, url || '/')
            }

            callback(err)
        })
    }

    onLoginAsCustomer(customer, callback) {
        // With 2FA the tab is opened after the code is verified, admins don't need a code
        const mfaExpected = customer.settings?.mfaRequired && !isAdminToken(sessionStorage.token)
        const win = mfaExpected ? null : openHandoverTab()

        socket.emit('login.loginAsCustomer', sessionStorage.token, customer._id, (err, token, decoded) => {
            if (err) {
                closeHandoverTab(win)
                callback(err)
            } else if (decoded?.mfaPending) {
                closeHandoverTab(win)

                // showMfaPopup gets the error when the code couldn't be mailed
                callback(undefined, (showMfaPopup) => {
                    sessionStorage.customerToken = token

                    if (customer.mfaMethod === 'email') {
                        this.onMailMFACode(token, undefined, undefined, (err) => {
                            typeof showMfaPopup === 'function' && showMfaPopup(err)
                        })
                    } else {
                        typeof showMfaPopup === 'function' && showMfaPopup()
                    }
                })
            } else {
                sendToken(win, token, '/klant')
                callback()
            }
        })
    }

    link(user) {
        let link = '/login'

        if (user.isCustomer) {
            if (user.permissions?.orders || user.permissions?.ordersRead) {
                return '/klant/ritten'
            }
            return '/klant/zendingen'
        }

        if (user.isAdmin) {
            return '/admin'
        }

        if (user.isReseller) {
            _.keys(user.permissions).map((permission) => {
                if (user.permissions[permission] && link === '/login') {
                    if (permission === 'orders') {
                        link = '/planning'
                    } else if (permission === 'parcels') {
                        link = '/zendingen'
                    } else if (permission === 'shifts') {
                        link = '/diensten'
                    } else if (permission === 'subscriptions') {
                        link = '/abonnementen'
                    } else if (permission === 'customers') {
                        link = '/klanten'
                    } else if (permission === 'invoices') {
                        link = '/facturatie'
                    } else if (permission === 'users') {
                        link = '/gebruikers'
                    } else if (permission === 'settings') {
                        link = '/instellingen'
                    }
                }
            })
        }

        return link
    }

    onLogout() {
        sessionStorage.removeItem('token')
        clearStoredDates()
        localStorage.removeItem('lastActiveTime')
        window.location = '/login'
    }

    onLoggedIn(callback) {
        const loggedIn = !!sessionStorage.token

        callback(loggedIn, loggedIn && this.link(this.state.user))
    }

    onGetAccount(callback) {
        socket.emit('login.getAccount', sessionStorage.token, (err, user) => {
            if (!err) {
                this.setState({user: {...this.state.user, ...user}, accounts: user.accounts})

                if (!user.isOwner && user.branchIds?.length) {
                    const intersected = this.state.selectedBranchIds.filter((id) => user.branchIds.includes(id))

                    if (intersected.length !== this.state.selectedBranchIds.length) {
                        this.onSetSelectedBranches(intersected)
                    }
                }
            }

            typeof callback === 'function' && callback(err, user)
        })
    }

    onSetSelectedBranches(selectedBranchIds) {
        localStorage.selectedBranchIds = JSON.stringify(selectedBranchIds || [])
        this.setState({selectedBranchIds: selectedBranchIds || []})
    }

    onUpdateUserSettings(user, callback) {
        if (user.isCustomer) {
            socket.emit('customers.updateSettings', sessionStorage.token, user, callback)
        }
    }

    onGetShippingMethods(user, callback) {
        LoginActions.updateUserSettings(user, () => {
            socket.emit('customers.getShippingMethods', sessionStorage.token, callback)
        })
    }

    onInstallLightspeed(language, timestamp, token, signature, clusterId, shopId, callback) {
        socket.emit('customers.installLightspeed', sessionStorage.token, language, timestamp, token, signature, clusterId, shopId, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onUninstallLightspeed(language, shopId, timestamp, signature, callback) {
        socket.emit('customers.uninstallLightspeed', sessionStorage.token, language, shopId, timestamp, signature, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onInstallShopify(code, hmac, nonce, shop, callback) {
        socket.emit('customers.installShopify', sessionStorage.token, code, hmac, nonce, shop, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onInstallExactOnline(code, callback) {
        socket.emit('customers.installExactOnline', sessionStorage.token, code, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onVerifyWebshop(webshop, callback) {
        socket.emit('customers.verifyWebshop', sessionStorage.token, webshop, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onCreateWebshopWebhook(webshop, callback) {
        socket.emit('customers.createWebshopWebhook', sessionStorage.token, webshop, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onDeleteWebshopWebhook(webshop, callback) {
        socket.emit('customers.deleteWebshopWebhook', sessionStorage.token, webshop, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onInstallMollie(code, callback) {
        socket.emit('customers.installMollie', sessionStorage.token, code, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onGetMollieProfiles(callback) {
        socket.emit('customers.getMollieProfiles', sessionStorage.token, (err) => {
            if (!err) {
                LoginActions.getAccount((err) => callback(err))
            } else {
                callback(err)
            }
        })
    }

    onGetReseller() {
        const {user} = this.state

        if (!user.isAdmin) {
            socket.emit('login.getReseller', sessionStorage.token, (err, reseller, domain) => {
                if (!err) {
                    if (checkRedirectToNewDomain(domain, true, reseller?.settings?.brandingEnabled)) return
                    this.setState({reseller})
                }
            })
        }
    }

    onUpdateReseller(path) {
        const {user} = this.state

        if (!user.isAdmin) {
            socket.emit('resellers.updateReseller', sessionStorage.token, path, (err, value) => {
                if (!err) {
                    const reseller = {...this.state.reseller}

                    _.set(reseller, path, value)

                    this.setState({reseller})
                }
            })
        }
    }

    onUpdateResellerSettings(...args) {
        socket.emit('resellers.updateSettings', sessionStorage.token, ...args)
    }

    /**
     * Stores the CSV import column layout for one customer; the local reseller copy is only updated once the server confirms.
     *
     * @param {'orders' | 'parcels'} type
     * @param {string} customerId
     * @param {string[]} columns
     * @param {Object} [csvOptions] only for parcels
     * @param {'delivery' | 'pickup' | 'pickupDelivery' | 'multiOrder'} [orderType] only for orders, stores the layout for this order type
     * @param {function} [callback]
     */
    onUpdateCsvColumns(type, customerId, columns, csvOptions, orderType, callback) {
        socket.emit('resellers.updateCsvColumns', sessionStorage.token, type, customerId, columns, csvOptions, orderType, (err) => {
            if (!err) {
                const reseller = {...this.state.reseller}

                _.set(reseller, orderType ? ['settings', 'orders', 'csvColumnsPerOrderType', customerId, orderType] : ['settings', type, 'csvColumns', customerId], columns)

                if (type === 'parcels' && csvOptions) {
                    _.set(reseller, ['settings', 'parcels', 'csvOptions', customerId], csvOptions)
                }

                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {string} partnerKey
     * @param {('outgoing' | 'incoming')[]} directions
     * @param {function} callback
     */
    onAddPartner(partnerKey, directions, callback) {
        socket.emit('resellers.addPartner', sessionStorage.token, partnerKey, directions, (err, reseller) => {
            if (!err) {
                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {string} partnerKey
     * @param {function} callback
     */
    onAddParcelPartner(partnerKey, callback) {
        socket.emit('resellers.addParcelPartner', sessionStorage.token, partnerKey, (err, reseller) => {
            if (!err) {
                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {string} partnerId
     * @param {'accepted' | 'rejected' | 'remove'} action
     * @param {'outgoing' | 'incoming' | null} direction - required for 'remove', for 'accepted'/'rejected' only that direction
     * @param {function} callback
     */
    onHandlePartnerRequest(partnerId, action, direction, callback) {
        socket.emit('resellers.handlePartnerRequest', sessionStorage.token, partnerId, action, direction, (err, reseller) => {
            if (!err) {
                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {string} partnerId
     * @param {'outgoing' | 'incoming'} direction
     * @param {function} callback
     */
    onRemovePartner(partnerId, direction, callback) {
        socket.emit('resellers.removePartner', sessionStorage.token, partnerId, direction, (err, reseller) => {
            if (!err) {
                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {'outgoing' | 'incoming'} direction
     * @param {object} partnerSettings
     * @param {function} callback
     */
    onUpdatePartnerSettings(direction, partnerSettings, callback) {
        socket.emit('resellers.updatePartnerSettings', sessionStorage.token, direction, partnerSettings, (err, reseller) => {
            if (!err) {
                this.setState({reseller})
            }

            typeof callback === 'function' && callback(err)
        })
    }

    /**
     * @param {string} subscriptionKey
     * @param {string} clientKey
     * @param {function} callback
     */
    onMakeSnelStartVerificationRequests(subscriptionKey, clientKey, callback) {
        socket.emit('resellers.makeSnelStartVerificationRequests', sessionStorage.token, subscriptionKey, clientKey, callback)
    }

    onGetPartners() {
        // An admin (not logged in as a reseller) has no partners
        if (isAdminToken(sessionStorage.token)) {
            return
        }

        socket.emit('resellers.getPartners', sessionStorage.token, (err, partners) => {
            if (!err) {
                const partnerObject = {}

                partners.map((partner) => {
                    partnerObject[partner._id] = partner
                })

                this.setState({partners: partnerObject})
            }
        })
    }

    onSendResetPasswordMail(...args) {
        socket.emit('login.sendResetPasswordMail', ...args)
    }

    onResetPassword(token, password, callback) {
        socket.emit('login.resetPassword', token, password, callback)
    }

    onGenerateMFAKey(token, accountIndex, callback) {
        socket.emit('login.generateMFAKey', sessionStorage.token || token, accountIndex, callback)
    }

    onMailMFACode(token, ...args) {
        socket.emit('login.mailMFACode', sessionStorage.customerToken || sessionStorage.token || token, ...args)
    }

    onReset2FA(token, ...args) {
        socket.emit('login.reset2FA', sessionStorage.token || token, ...args)
    }

    onVerify2FACode(...args) {
        socket.emit('login.verify2FACode', sessionStorage.customerToken || sessionStorage.token, ...args)
    }

    onSendCustomerWelcomeMail(customer, callback) {
        socket.emit('login.sendCustomerWelcomeMail', sessionStorage.token, customer, callback)
    }

    onSendUserWelcomeMail(user, callback) {
        socket.emit('login.sendUserWelcomeMail', sessionStorage.token, user, callback)
    }

    onCheckNotifications(callback) {
        socket.emit('login.checkNotifications', sessionStorage.token, (err, notifications) => {
            if (!err && notifications) {
                this.setState({notifications})

                typeof callback === 'function' && callback()
            } else {
                console.log(err)
            }
        })
    }

    onUpdateReadNotifications(...args) {
        socket.emit('login.updateReadNotifications', sessionStorage.token, ...args)
    }

    onGetBranding(domain, callback) {
        socket.emit('login.getBranding', domain, (err, branding) => {
            this.setState({branding})
            typeof callback === 'function' && callback(err, branding)
        })
    }
}

function checkRedirectToNewDomain(brandingDomain, keepPath, brandingEnabled) {
    let newDomain
    const currentDomain = `${location.protocol}//${location.host}`
    const currentHostname = location.hostname

    if (!brandingDomain || (!brandingEnabled && ![brandingDomain, 'localhost', 'dev.veloyd.nl', 'test.veloyd.nl', 'app.veloyd.nl'].includes(currentHostname))) {
        if (currentHostname.includes('localhost')) {
            newDomain = `${location.protocol}//localhost${location.port ? `:${location.port}` : ''}`
        }

        if (currentHostname.includes('veloyd.nl')) {
            newDomain = `${location.protocol}//app.veloyd.nl`
        }

        if (currentHostname.includes('test.veloyd.nl')) {
            newDomain = `${location.protocol}//test.veloyd.nl`
        }

        if (currentHostname.includes('dev.veloyd.nl')) {
            newDomain = `${location.protocol}//dev.veloyd.nl`
        }
    } else if (brandingEnabled) {
        newDomain = `${location.protocol}//${brandingDomain}${process.env.NODE_ENV === 'local' && location.port ? `:${location.port}` : ''}`

        if (currentHostname === 'localhost') {
            newDomain = `${location.protocol}//${brandingDomain}${process.env.NODE_ENV === 'local' && location.port ? `:${location.port}` : ''}`
        }
    } else {
        newDomain = currentDomain
    }

    if (newDomain && newDomain !== currentDomain && !sessionStorage.noDomainRedirect) {
        if (keepPath) {
            newDomain = `${newDomain}${location.pathname}${location.search}`
        }

        // Logout current user
        sessionStorage.removeItem('token')
        clearStoredDates()
        localStorage.removeItem('lastActiveTime')

        window.location.href = newDomain
        return true
    }
}
